import uniq from 'lodash/uniq';
import { copy } from 'Common/Functions/Copy';
import { HOST_CREATE_UPDATE_SUCCESS } from 'store/HostEditCreate/types';
import * as types from './types';
import initialState from './initialState';

function host (state = initialState, action) {
  switch (action.type) {
    case types.SHOW_HOST_LEFT_FILTERS: {
      return {
        ...state,
        showLeftFilters: action.visible
      };
    }
    case types.SET_HOSTS_FILTER_ERROR: {
      return {
        ...state,
        isFetching: false
      };
    }
    case types.GET_DATA_HOST_START: {
      return {
        ...state,
        isFetching: true
      };
    }
    case types.GET_DATA_HOST_FAIL: {
      return {
        ...state,
        isFetching: false,
        error: true,
        errorMessage: action.data
      };
    }
    case types.GET_DATA_HOST_SUCCESS: {
      return {
        ...state,
        isFetching: false,
        hostList: action.data,
        hostCount: action.hostCount,
        hostDetail: action.host ? copy(action.host) : false
      };
    }
    case types.UPDATE_DATA_HOST_LIST: {
      return {
        ...state,
        hostList: action.hostList
      };
    }
    case types.APPEND_DATA_HOST_LIST: {
      const { hostList } = state;
      return {
        ...state,
        hostList: [action.hostRow, ...hostList]
      };
    }
    case types.GET_DATA_HOST_SEARCH: {
      return {
        ...state,
        filters: action.value
      };
    }
    case types.GET_DATA_HOST_GROUP_BY_RESET: {
      return {
        ...state,
        groupBy: '',
        mapGroupByIndex: []
      };
    }
    case types.GET_DATA_HOST_GROUP_BY_EXPAND: {
      const { mapGroupByIndex } = state;
      const newMapGroupByIndex = { ...mapGroupByIndex, [action.index]: action.data };
      const hostList = state.hostList;
      hostList[action.index].groupData = action.data;

      return {
        ...state,
        mapGroupByIndex: newMapGroupByIndex,
        hostList,
        isFetching: false
      };
    }
    case HOST_CREATE_UPDATE_SUCCESS: {
      return {
        ...state,
        showModalEditCreate: false
      };
    }
    case types.TOGGLE_MODAL_EDIT_CREATE_HOST: {
      return {
        ...state,
        showModalEditCreate: action.value
      };
    }
    case types.HOST_SELECTED: {
      return {
        ...state,
        hostsSelected: uniq([...state.hostsSelected, ...action.payload])
      };
    }
    case types.HOST_UNSELECTED: {
      const filterByID = (array, id) => array.filter((el) => el._id !== id);
      const newHostsSelected = action.payload.reduce((hostsSelected, hostToDelete) => filterByID(hostsSelected, hostToDelete._id), state.hostsSelected);

      return {
        ...state,
        hostsSelected: newHostsSelected
      };
    }
    case types.NEW_PIVOT: {
      return {
        ...state,
        lastSelected: action.payload
      };
    }
    case types.SELECT_ALL_HOST: {
      return {
        ...state,
        hostsSelected: [...action.hostsList]
      };
    }
    case types.UNSELECT_ALL_HOST: {
      return {
        ...state,
        hostsSelected: []
      };
    }
    case types.RESET_STATE_HOST: {
      return {
        ...copy(initialState),
        fields: state.fields,
        page: 1
      };
    }
    case types.SHOW_MODAL_DELETE_HOSTS: {
      return {
        ...state,
        showDeleteConfirmation: true
      };
    }
    case types.HIDE_MODAL_DELETE_HOSTS: {
      return {
        ...state,
        showDeleteConfirmation: false
      };
    }
    case types.DELETE_HOSTS_START: {
      return {
        ...state,
        isFetching: true
      };
    }
    case types.DELETE_HOSTS_SUCCESS: {
      return {
        ...state,
        hostsSelected: [],
        isFetching: false
      };
    }
    case types.DELETE_HOSTS_FAIL: {
      return {
        ...state,
        isFetching: false
      };
    }
    case types.UPDATE_HOST_SELECTED: {
      return {
        ...state,
        hostsSelected: action.host
      };
    }
    default: {
      return state;
    }
  }
}

export default host;
